import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "conteneurNomEtablissement" }
const _hoisted_2 = {
  key: 0,
  class: "labelNomEtablissement"
}
const _hoisted_3 = {
  key: 0,
  class: "conteneurNomResidentEtFamille"
}
const _hoisted_4 = { class: "labelNomFamille" }
const _hoisted_5 = { class: "image-block" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "labelNomResident" }
const _hoisted_8 = {
  key: 1,
  class: "conteneurDatesSemaine"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "labelDateSemaine" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 2,
  class: "blocPlanning"
}
const _hoisted_13 = {
  key: 3,
  class: "blocMessageDansPlanning"
}
const _hoisted_14 = {
  key: 4,
  class: "ensembleMessageErreur"
}
const _hoisted_15 = { class: "texteMessageErreur" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AfficheurJourPlanning = _resolveComponent("AfficheurJourPlanning")!
  const _component_AfficheurPopup = _resolveComponent("AfficheurPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.nomEtablissementAffiche)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.nomEtablissementAffiche), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.nomResident != '' && _ctx.nomFamille != '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.nomFamille), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: require('@/assets/telephone.png'),
              alt: "LogoAppel",
              class: "full-height-image"
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.nomResident), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.texteDatesSemaines != '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("img", {
            src: require('@/assets/fleche.png'),
            alt: "flechePrecedant",
            class: "conteneurBoutonSemainePrecedante",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clicVoirSemainePrecedante && _ctx.clicVoirSemainePrecedante(...args)))
          }, null, 8, _hoisted_9),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.texteDatesSemaines), 1),
          _createElementVNode("img", {
            src: require('@/assets/fleche.png'),
            alt: "flecheSuivant",
            class: "conteneurBoutonSemaineSuivante",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clicVoirSemaineSuivante && _ctx.clicVoirSemaineSuivante(...args)))
          }, null, 8, _hoisted_11)
        ]))
      : _createCommentVNode("", true),
    (_ctx.DataCommune.SemaineAffichee != '' && _ctx.DataCommune.messageDansPlanning == '' && _ctx.DataCommune.listResaSemaineActuellementAffiche != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (index) => {
            return _createElementVNode("div", {
              class: "jourPlanning",
              key: index
            }, [
              _createVNode(_component_AfficheurJourPlanning, { pointerJour: index }, null, 8, ["pointerJour"])
            ])
          }), 64))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.DataCommune.messageDansPlanning), 1)),
    _createVNode(_component_AfficheurPopup),
    (_ctx.messageErreur)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.messageErreur), 1),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clicRechargerLaPage())),
            class: "boutonRechargerLaPage"
          }, "Recharger la page")
        ]))
      : _createCommentVNode("", true)
  ], 64))
}